import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <motion.a
      data-testid="whatsapp-chat-button"
      href="https://wa.me/254720577583?text=Hello%20Musesya%20%26%20Company%20Advocates%2C%20I%20would%20like%20to%20make%20an%20enquiry."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with the firm on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.1 }}
      className="fixed bottom-6 left-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-gold text-navy-950 shadow-[0_0_30px_rgba(154,136,15,0.4)] hover:bg-gold-hover transition-colors"
    >
      <MessageCircle size={24} />
    </motion.a>
  );
}
